















import Vue from "vue";
import { features, maps } from "@/store";
import { LLayerGroup } from "vue2-leaflet";
import PointComponent from "./PointComponent.vue";
import { icon, LeafletMouseEvent } from "leaflet";
import Component from "vue-class-component";
import { IMobilePlatforms } from "@/store/features/models";
import { MutationTypes } from "@/store/mutations-types";
import bboxFilter from "@/utils/bbox_filter";

const platformIconUrl = require("../../../assets/icons/maps/mobile_platform.svg");

@Component({
  components: {
    LLayerGroup,
    PointComponent,
  },
})
export default class MobilePlatformsLayer extends Vue {
  //computed:
  get iconGenerator() {
    return icon({
      iconUrl: platformIconUrl,
      iconSize: [45, 45],
    });
  }

  get mobilePlatforms() {
    return features.getters.mobilePlatforms;
  }
  get platformTagEnabled() {
    return features.getters.platformTagEnabled;
  }
  get selectedMobilePlatform() {
    return features.getters.selectedMobilePlatform;
  }
  get measurementActivated() {
    return maps.getters.measurementActivated;
  }
  get platformsTagsEnabledByZoom() {
    return maps.getters.platformsTagsEnabledByZoom;
  }
  get filteredPlatforms() {
    return bboxFilter(this.mobilePlatforms, "geometry");
  }

  //methods
  loadFeatures() {
    if (!this.mobilePlatforms.length) {
      features.dispatch("getMobilePlatforms");
    }
  }
  coords(platform: IMobilePlatforms) {
    let coordenadas = platform.geometry.coordinates;
    return [coordenadas[1], coordenadas[0]];
  }
  clickHandler(value: LeafletMouseEvent) {
    if (this.measurementActivated) {
      let coords = value.latlng;
      maps.commit(MutationTypes.ADD_MEASUREMENT_POINT, {
        tipo: "mobilePlatform",
        data: coords,
      });
    }
  }

  created() {
    this.loadFeatures();
  }
}
